import React from 'react'

const avatarTints: Array<{ bg: string; fg: string }> = [
  { bg: '#EEF2FF', fg: '#4338CA' },
  { bg: '#ECFDF5', fg: '#047857' },
  { bg: '#FEF3C7', fg: '#92400E' },
  { bg: '#FEF2F2', fg: '#B91C1C' },
  { bg: '#FAF5FF', fg: '#7E22CE' },
]

const tintFor = (name: string) => {
  const code = name.trim().charCodeAt(0)
  const i = Number.isNaN(code) ? 0 : code % avatarTints.length
  return avatarTints[i]
}

export interface CategoryAvatarProps {
  name: string
  image?: string
  /** Square size in px. Defaults to 28 (excluded-categories table row). */
  size?: number
}

// Mirrors the Category list thumbnail: render the category image when one is
// available, otherwise fall back to a tinted avatar showing the first
// character of the name (see WebCategoriesTab row thumbnail).
export const CategoryAvatar: React.FC<CategoryAvatarProps> = ({
  name,
  image,
  size = 28,
}) => {
  const tint = tintFor(name)
  const letter = name.trim().charAt(0).toUpperCase() || '#'
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size >= 24 ? 6 : 4,
        flexShrink: 0,
        background: image
          ? `url("${image}") center / cover no-repeat`
          : tint.bg,
        border: '1px solid #E8ECF0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size >= 24 ? 12 : 10,
        fontWeight: 700,
        color: tint.fg,
      }}
    >
      {image ? null : letter}
    </div>
  )
}
